import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a6b983cb648b900140a589c_1787687340944_29049dfe/tranceformright/src/app/resources/page.tsx");
